export default {"src":"/_next/static/media/feature-1.32a3ad74.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};